import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';

import { routing }       from './pages.routing';
import { NgaModule } from '../theme/nga.module';

import { Pages } from './pages.component';

import {ExportAsModule} from 'ngx-export-as';


@NgModule({
  imports: [CommonModule, NgaModule, routing,ExportAsModule ],
  declarations: [Pages]
})
export class PagesModule {
}
